import type { TableColumns } from '@ohpen/enso-ui';
import { ErcProfile, PenaltyTier } from '@pmp/api';
import { ErcProfileData } from './interfaces';

export const ercColumns: TableColumns<ErcProfile> = [
  {
    title: 'pmp.erc.labels.ercProfileId',
    dataIndex: 'ercProfileId',
    key: 'ercProfileId',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.ercProfileName',
    dataIndex: 'name',
    key: 'name',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.penaltyValues',
    dataIndex: 'penaltyValues',
    key: 'penaltyValues',
    options: {
      format: {
        type: 'percentageList',
        decimalScale: 2,
      },
      filter: 'search',
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const periodColumns: TableColumns<PenaltyTier> = [
  {
    title: 'pmp.erc.labels.order',
    dataIndex: 'order',
    key: 'order',
    options: {
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.durationInMonths',
    dataIndex: 'durationInMonths',
    key: 'durationInMonths',
    options: {
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      format: {
        type: 'date',
      },
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.erc.labels.ercPercentage',
    dataIndex: 'penaltyPercentage',
    key: 'penaltyPercentage',
    options: {
      format: {
        type: 'percentage',
        decimalScale: 2,
      },
      filter: 'number',
      sorter: true,
    },
  },
];

export const ercProfilesFlatColumns: TableColumns<ErcProfileData> = [
  {
    title: 'pmp.erc.labels.ercProfileId',
    dataIndex: 'ercProfileId',
    key: 'ercProfileId',
    options: {},
  },
  {
    title: 'pmp.erc.labels.ercProfileName',
    dataIndex: 'name',
    key: 'name',
    options: {},
  },
  {
    title: 'pmp.erc.labels.order',
    dataIndex: 'order',
    key: 'order',
    options: {
      format: {
        type: 'number',
      },
    },
  },
  {
    title: 'pmp.erc.labels.durationInMonths',
    dataIndex: 'durationInMonths',
    key: 'durationInMonths',
    options: {
      format: {
        type: 'number',
      },
    },
  },
  {
    title: 'pmp.erc.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      format: {
        type: 'date',
      },
    },
  },
  {
    title: 'pmp.erc.labels.ercPercentage',
    dataIndex: 'penaltyPercentage',
    key: 'penaltyPercentage',
    options: {
      format: {
        type: 'percentage',
      },
    },
  },
];
